export const fmt = (n: number) => `${Number(n).toFixed(3)} KWD`;
export const r3 = (n: number) => parseFloat(n.toFixed(3));
export const r1 = (n: number) => parseFloat(n.toFixed(1));
export const pct = (a: number, b: number) =>
	b ? `${((a / b) * 100).toFixed(1)}%` : "0%";
export const mgn = (price: number, cost: number) =>
	price > 0 ? r1(((price - cost) / price) * 100) : 0;
export const mgnClass = (m: number) =>
	m > 60 ? "tag-green" : m > 40 ? "tag-amber" : "tag-red";

export const ROLE_COLORS: Record<string, string> = {
	admin: "#f59e0b",
	manager: "#3b82f6",
	cashier: "#06a384",
	waiter: "#a855f7",
	kitchen: "#ef4444",
};
export const ROLE_LABELS: Record<string, string> = {
	admin: "Admin",
	manager: "Manager",
	cashier: "Cashier",
	waiter: "Waiter",
	kitchen: "Kitchen",
};
